const constantes = {
    estatusSolicitudes: {
        abierta: 61,
        programada: 62,
        cerrada: 63,
    },
    estatusOrdenesTrabajo: {
        pteProgramar: 71,
        programada: 72,
        reprogramada: 73,
        MttoRealizado: 74,
        entradaTaller: 75,
        cancelado: 79,
    },
     estatusOrdenesTrabajoNombre: {      
        MttoRealizado: "MttoRealizado"       
    },
    puestos: {
        mecanicoA: 15,
        mecanicoB: 15,
        operador: 33,
        guardiaSeguridad: 31,
        coordinadorTrafico: 66,
        auxiliarTrafico: 64,
        gestorOperadores: 54,
        jefeTrafico:106
    },
    departamento: {
        Operaciones: 2,
        Trafico: 3,      
        Mantenimiento: 7
    },
    estatusRequisiciones:{
        Solicitada: 2       
    },
    tiposServicio: {
        MantenimientoCorrectivo: 261,
        MantenimientoPreventivo: 262,
    },
    estatusLlanta: {
        enUso: 81,
        enAlmacen: 82,
        enDesecho: 83,
        envioRenovado: 84,
        renovado: 85,
        rechazoRenovado: 86,
    },
    usuarioStorage: "usuarioABC",
    tiposUnidad: {
        Pipa: 2,
        Utilitario: 6,
    },

    estatusCheck: {
        Ok: 391,
        NecesitaServicio: 392,
        NA: 393,
    },
    estatusRenovacionLlanta: {
        envioRenovado: 181,
        renovado: 182,
        rechazoRenovado: 183,
    },
    empresa: {
        ABC: 1,
        TBX: 2,
        REX: 3,
        SCF: 4,
    },
};

export default constantes;
